import { createContext } from '@lit/context'
import { TSurfaceColor } from '@schmancy/types/surface'
export const SchmancyListTypeContext = createContext<TSurfaceColor>(undefined)
